export const en = {
    'banner-id': '№ {bannerId}'
};
